// src/pages/Viewers.jsx
import React, { useEffect, useState } from "react";
import api from "../api";
import {
  Box,
  Paper,
  Typography,
  Grid,
  Alert,
  Button
} from "@mui/material";

export default function Viewers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]   = useState("");

  const load = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await api.get(`/api/artifacts`);   // 🔥 Relative API
      setItems(res.data);
    } catch (err) {
      console.error(err);
      setError("Failed to load viewer stats. Please check WiFi / Server.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  if (loading)
    return (
      <Typography sx={{ textAlign: "center", mt: 4 }}>
        Loading viewer stats…
      </Typography>
    );

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Viewers (Scan counts)
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
          <Button
            size="small"
            variant="outlined"
            sx={{ ml: 2 }}
            onClick={load}
          >
            Retry
          </Button>
        </Alert>
      )}

      <Grid container spacing={2}>
        {!error &&
          items.map((a) => (
            <Grid item xs={12} sm={6} md={4} key={a._id}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="subtitle1">{a.title}</Typography>
                <Typography variant="h6">
                  {a.visitorCount || 0}
                </Typography>
              </Paper>
            </Grid>
          ))}

        {!error && items.length === 0 && (
          <Grid item xs={12}>
            <Typography>No data available.</Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
